import { combineReducers } from 'redux-immutable';
import { resourcesReducer } from 'iguazu-rest';
import { OneCache } from 'fetchye-one-app';
import { experimentsReducer } from '@americanexpress/one-experiments';
import productsReducer from 'axp-product-ducks';
import authReducer from './authDuck';
import elfLogsReducer from './elfLogsDucks';

export const reducer = combineReducers({
  experiments: experimentsReducer,
  fetchye: OneCache().reducer,
  resources: resourcesReducer,
  products: productsReducer,
  auth: authReducer,
  elfLogs: elfLogsReducer,
});

export default reducer;
